import React, { Fragment } from "react";
import "./pageLoader.scss";
import "../modal/modal.scss";

import CircularProgress from "@material-ui/core/CircularProgress";

const PageLoader = (props: any) => {
  return (
    <Fragment>
      <div className="pageLoader" style={props.customStyle}>
        <div>
          {/* <img src={loadingGif}></img> */}
          <CircularProgress size={50} />
        </div>
      </div>
    </Fragment>
  );
};
export default PageLoader;
